import { createApp } from 'vue';
import VCalendar from 'v-calendar';
import Maska from 'maska';

import AnalyticHelper from '@/helpers/analyticHelper';
import i18n from './plugins/i18n';
import App from './App.vue';
import router from './router';
import store from './store';

import currencyFormatMixin from './mixins/currencyFormat';

import '@/scss/_fonts.scss';
import '@/scss/fds.scss';

const appInstance = createApp(App);

const enableAnalytics = process.env.VUE_APP_ENABLE_ANALYTICS === 'true';

if (enableAnalytics) {
  const analytics = new AnalyticHelper();
  appInstance.config.globalProperties.$insights = analytics;
}

appInstance
  .use(i18n)
  .use(store)
  .use(router)
  .use(VCalendar)
  .use(Maska)
  .mixin(currencyFormatMixin)
  .mount('#app');
